export function checkAuthCallbackError(){
    const params = new URLSearchParams(window.location.search);

    const error = params.get('error');
    const errorDescription = params.get('error_description');
    return {error, errorDescription};
}


export function resetBrowserHistory() {
    history.replaceState({}, document.title, location.origin + location.pathname);
}
